// images
import facebook from '@images/footer/facebook.png';
import linkedIn from '@images/footer/linkedin.png';
import vk from '@images/footer/VK.png';
import instagram from '@images/footer/instagram.png';
import youtube from '@images/footer/youtube.png';
import telegram from '@images/footer/telegram.png';

export const iconsData = [
  {
    src: facebook,
    href: 'https://www.facebook.com/iTechArt.Group',
  },
  {
    src: linkedIn,
    href: 'https://www.linkedin.com/company/itechart-group',
  },
  { src: vk, href: 'https://vk.com/itechart.group' },
  {
    src: instagram,
    href: 'https://www.instagram.com/itechart_official',
  },
  {
    src: youtube,
    href: 'https://www.youtube.com/user/iTechArt',
  },
  {
    src: telegram,
    href: 'https://t.me/itechart_life',
  },
];
